import React, { Fragment } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, setStatus } from "redux/GeneralReducers/GeneralActions";
import { postRequest, patchRequest, delRequest } from "config/axios";
import Buttons from "components/body/buttons/Button";

const ModalTambahKlasifikasi = (props) => {
  const dispatch = useDispatch();
  const { GeneralReducers } = useSelector((state) => state);

  const { data, setModal, getList } = props;

  const createKlasifikasi = () => {
    dispatch(setLoading(true));
    postRequest(`egs/master/klasifikasi`, { ...data.klasifikasi })
      .then(() => {
        dispatch(setLoading(false));
        dispatch(
          setStatus({
            status: "success klasifikasi",
            msg: "Data berhasil ditambah",
          })
        );
        getList();
        setModal({ ...data, modal: false });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err.request.status === 401) {
          dispatch(setStatus({ status: "401", msg: "Unauthorization" }));
        } else {
          dispatch(setStatus({ status: "fail", msg: "Data gagal ditambah" }));
        }
      });
  };

  const updateKlasifikasi = () => {
    let id = data.klasifikasi.id;
    dispatch(setLoading(true));
    patchRequest(`egs/master/klasifikasi/${id}`, { ...data.klasifikasi })
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(
          setStatus({
            status: "success klasifikasi",
            msg: "Data berhasil diubah",
          })
        );
        getList();

        setModal({ ...data, modal: false });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err.request.status === 401) {
          dispatch(setStatus({ status: "401", msg: "Unauthorization" }));
        } else {
          dispatch(setStatus({ status: "fail", msg: "Data gagal di ubah" }));
        }
      });
  };

  const deleteKlasifikasi = () => {
    let id = data.klasifikasi.id;
    dispatch(setLoading(true));
    delRequest(`egs/master/klasifikasi/${id}`)
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(
          setStatus({
            status: "success klasifikasi",
            msg: "Data berhasil dihapus",
          })
        );
        getList();

        setModal({ ...data, modal: false });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err.request.status === 401) {
          dispatch(setStatus({ status: "401", msg: "Unauthorization" }));
        } else {
          dispatch(setStatus({ status: "fail", msg: "Data gagal di hapus" }));
        }
      });
  };
  return (
    <Fragment>
      <Modal
        size="lg"
        show={data.modal}
        onHide={() => setModal({ modal: false, klasifikasi: {} })}
        aria-labelledby="example-modal-sizes-title-lg"
        animation={false}
      >
        <Modal.Header className="header-modal" closeButton>
          <Modal.Title
            className="title-modal"
            id="example-modal-sizes-title-lg"
          >
            {data.action || "Tambah"}{" "}
            {data.klasifikasi
              ? `${data.klasifikasi.nama_parent}`
              : "klasifikasi"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row reset-margin-row">
            <div className="col-md-12 content-modal">
              <div className="container-fluid">
                {GeneralReducers.status === "fail" && (
                  <div className="alert alert-danger">
                    {GeneralReducers.msg}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="lokasi">Kode*</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={data.klasifikasi && data.klasifikasi.kode}
                    onChange={(e) =>
                      setModal({
                        ...data,
                        klasifikasi: {
                          ...data.klasifikasi,
                          kode: e.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lokasi">Nama*</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={data.klasifikasi && data.klasifikasi.nama}
                    onChange={(e) =>
                      setModal({
                        ...data,
                        klasifikasi: {
                          ...data.klasifikasi,
                          nama: e.target.value,
                        },
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="row reset-margin-row ">
            <div className="col-md-12 text-right mb-3">
              {GeneralReducers.loading && (
                <i className="fa fa-spinner fa-pulse fa-fw cover-empty mr-2"></i>
              )}
              {data.action === "ubah" && (
                <Buttons
                  onClick={deleteKlasifikasi}
                  className="btn btn-danger pull-left"
                >
                  Hapus
                </Buttons>
              )}
              <Buttons
                className="btn btn-default mr-2"
                onClick={() => setModal({ modal: false, klasifikasi: {} })}
              >
                Batal
              </Buttons>

              <Buttons
                onClick={() => {
                  if (data.action === "Tambah Child") {
                    createKlasifikasi();
                  } else if (data.action === "ubah") {
                    updateKlasifikasi();
                  }
                }}
                className="btn btn-primary mr-2"
                disabled={GeneralReducers.loading}
              >
                Simpan
              </Buttons>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default ModalTambahKlasifikasi;
